<template>
  <div class="channel-dialog-container">
    <PostChannel :channelList="channelList" :postingChannels="postingChannels" :loading="channelLoading" @save="handelPublishChannel" @manualAdd="handleManualPublish"/>
    <div class="post-history-container">
      <el-collapse>
        <el-collapse-item>
          <template #title>
            <span class="title-label">{{ $t(`${i18nPrefix}.label.postHistory`) }}</span>
            <span class="collapse-label"></span>
          </template>
          <div class="table-container">
            <el-table
              :data="postHistoryList"
            >
              <el-table-column
                prop="post_time"
                :label="$t(`${i18nPrefix}.label.postTaskTime`)">
              </el-table-column>
              <el-table-column :label="$t(`${i18nPrefix}.label.postTaskStatus`)">
                <template #default="{ row }">
                  <div class="status-container">
                    <span :class="['status-label', `status-${row.status}`]">{{ $t(`${i18nPrefix}.label.${row.status === JOB_POSTING_STATUS.FINISHED ? 'finished' : 'inProgress'}`) }}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="channel" :label="$t(`${i18nPrefix}.label.postChannel`)">
                <template #default="{ row }">
                  <div class="channel-container">
                    <div :class="['op-icon', `op-status-${row.operation_type}`]"></div>
                    <div :class="['channel-icon', `channel-${row.channel.key}`]"></div>
                    <div :class="['status-icon', `task-status-${row.status}`]"></div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="finished_time" :label="$t(`${i18nPrefix}.label.postTaskFinishTime`)">
              </el-table-column>
            </el-table>
            <RectLoading class="history-loading" v-show="historyLoading"/>
          </div>
          <div class="pagination-container">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pageSetting.total"
              :current-page="pageSetting.currentPage"
              @current-change="handelPageChange"
              >
            </el-pagination>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
    <DialogWrapper
      appendToBody
      :show.sync="dialog.show"
      :title="$t(`${i18nPrefix}.label.selectChannelAccount`)"
      @save="handleSelectChannelAccount"
    >
      <div class="channel-account">
        <el-radio-group v-model="selectedChannelAccount">
          <el-radio
            v-for="channelAccount in channelAccountList"
            :label="channelAccount"
            :key="channelAccount.id"
          >
            {{ channelAccount.username }}
          </el-radio>
        </el-radio-group>
      </div>
    </DialogWrapper>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import RectLoading from '@/components/loading/rectLoading'
import PostChannel from '@/components/job/postChannel/channelContent.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import {
  CHANNEL_OPERATION_ADD, CHANNEL_OPERATION_HIDE, CHANNEL_OPERATION_UPDATE,
  CHANNEL_OPERATION_PUBLISH, DEFAULT_CHANNEL_ID, CHANNEL_URL_MAP
} from '@/constant/job'
import { OPERATION_TYPE, JOB_POSTING_STATUS } from '@/constant/company'
import { addQueryInPath } from '@/utils/common'

export default {
  components: {
    RectLoading,
    PostChannel,
    DialogWrapper
  },
  props: {
    jobId: {
      required: true
    },
    postingChannels: {
      default: []
    }
  },
  data () {
    return {
      OPERATION_TYPE,
      JOB_POSTING_STATUS,
      i18nPrefix: 'admin.job.list',
      channelList: [],
      postHistoryList: [],
      channelLoading: false,
      historyLoading: false,
      pageSetting: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      },
      dialog: {
        show: false
      },
      channelAccountList: [],
      publishChannelId: null,
      selectedChannelAccount: null
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    isProcessing () {
      if (_.find(this.postingChannels, ['is_pending', true])) {
        return true
      }
      if (_.find(this.postHistoryList, ['status', '1'])) {
        return true
      }
      return false
    },
    postingChannelMapping () {
      const result = {}
      _.forEach(this.postingChannels, (item) => {
        result[item.id] = item
      })
      return result
    },
    hasChangeChannel () {
      let result = false
      _.forEach(this.channelList, (channel) => {
        if (channel.newStatus !== '' && channel.newStatus !== channel.originStatus) {
          result = true
        }
      })
      return result
    }
  },
  created () {
    this.initJobChannel()
    this.initJobPostTaskHistory()
  },
  methods: {
    ...mapActions('company', ['getCompanyJobPostingChannelList', 'getCompanyJobPostingTaskHistory', 'createCompanyJobPostingTask']),
    ...mapActions('jobPosting', ['checkJobPostingChannel']),
    handelPageChange (currentPage) {
      this.pageSetting.currentPage = currentPage
      this.initJobPostTaskHistory()
    },
    async initJobChannel () {
      this.channelLoading = true
      try {
        const resp = await this.getCompanyJobPostingChannelList({ job_id: this.jobId })
        if (resp && resp.post_channels) {
          this.channelList = _.map(resp.post_channels, channel => {
            channel.label = channel.name
            channel.cn_label = channel.cn_name
            if (channel.id === DEFAULT_CHANNEL_ID) {
              channel.label = 'Career Site'
              channel.cn_label = '职位主页'
            }
            addI18nProperty(channel, 'i18nName', 'cn_label', 'label')
            const postingInfo = this.postingChannelMapping[channel.id]
            this.$set(channel, 'originStatus', 'none')
            this.$set(channel, 'newStatus', '')
            if (postingInfo && postingInfo.operation_type) {
              if (postingInfo.status === JOB_POSTING_STATUS.FINISHED) {
                channel.originStatus = postingInfo.operation_type === OPERATION_TYPE.DELETE ? 'none' : CHANNEL_OPERATION_PUBLISH
              } else if (postingInfo.operation_type === OPERATION_TYPE.ADD) {
                channel.originStatus = CHANNEL_OPERATION_ADD
              } else if (postingInfo.operation_type === OPERATION_TYPE.DELETE) {
                channel.originStatus = CHANNEL_OPERATION_HIDE
              } else if (postingInfo.operation_type === OPERATION_TYPE.UPDATE) {
                channel.originStatus = CHANNEL_OPERATION_UPDATE
              }
            }
            const channelPostTask = _.find(this.postingChannels, channelPostTask => channelPostTask.id === channel.id)
            channel.isPending = false
            if (channelPostTask) {
              channel.isPending = channelPostTask.is_pending
            }
            return channel
          })
        }
      } finally {
        this.channelLoading = false
      }
    },
    async initJobPostTaskHistory () {
      this.historyLoading = true
      try {
        const params = { job_id: this.jobId, page: this.pageSetting.currentPage, page_size: this.pageSetting.pageSize }
        const resp = await this.getCompanyJobPostingTaskHistory(params)
        if (resp) {
          this.postHistoryList = resp.list
          this.pageSetting.total = resp.total
        }
      } finally {
        this.historyLoading = false
      }
    },
    async handelPublishChannel (channelOperation) {
      const params = {
        job_id: this.jobId,
        channels_operation: channelOperation
      }
      const resp = await this.createCompanyJobPostingTask(params)
      if (resp) {
        _.forEach(this.channelList, (channel) => {
          if (channel.newStatus !== '') {
            if (channel.id === DEFAULT_CHANNEL_ID && channel.newStatus === CHANNEL_OPERATION_HIDE) {
              channel.originStatus = 'none'
            } else if (channel.id === DEFAULT_CHANNEL_ID && channel.newStatus === CHANNEL_OPERATION_ADD) {
              channel.originStatus = CHANNEL_OPERATION_PUBLISH
            } else {
              channel.originStatus = channel.newStatus
            }
            channel.newStatus = ''
          }
        })
        this.$message.success(this.$t(`${this.i18nPrefix}.message.postingJobSuccess`))
        this.initJobPostTaskHistory()
        this.$emit('handelRefresh')
      }
    },
    handleManualPublish (channel) {
      this.channelAccountList = channel.channel_accounts
      this.publishChannelId = channel.id
      if (!this.channelAccountList || this.channelAccountList.length === 0) {
        this.$message.info(this.$t('admin.company.jobPostingChannelAccount.message.noChannelAccount'))
        return
      }
      if (this.channelAccountList.length === 1) {
        this.selectedChannelAccount = this.channelAccountList[0]
        this.handleSelectChannelAccount()
        return
      }
      this.dialog.show = true
    },
    refresh () {
      this.channelLoading = true
      Promise.all([
        this.initJobChannel(),
        this.initJobPostTaskHistory()
      ]).finally(() => {
        this.channelLoading = false
      })
    },
    async handleSelectChannelAccount () {
      this.dialog.show = false
      this.channelLoading = true
      try {
        const resp = await this.checkJobPostingChannel({ job_id: this.jobId, channel_id: this.publishChannelId })
        if (!resp.can_post) {
          return
        }
      } finally {
        this.channelLoading = false
      }
      const channelUrl = CHANNEL_URL_MAP[this.publishChannelId]
      let channelLoginUrl = channelUrl.LOGIN_URL
      let channelPublishUrl = channelUrl.PUBLISH_URL
      const publishParams = {
        _auto_job_post: 1
      }
      channelPublishUrl = addQueryInPath(channelPublishUrl, publishParams)
      const loginParams = {
        _auto_job_post: 1
      }
      channelLoginUrl = addQueryInPath(`${channelLoginUrl}${encodeURIComponent(channelPublishUrl)}`, loginParams)
      window.addEventListener('message', this.sendJobPostingInfo)
      this.$emit('jobPostingManual')
      window.open(channelLoginUrl)
    },
    sendJobPostingInfo (event) {
      const channelUrl = CHANNEL_URL_MAP[this.publishChannelId]
      if (event.data !== 'getJobPostingInfo') {
        return
      }
      const host = _.find(channelUrl.HOST, host => host === event.origin)
      if (!host) {
        return
      }
      event.source.postMessage({
        type: 'jobPostingInfo',
        channelAccountId: this.selectedChannelAccount.id,
        jobId: this.jobId
      }, event.origin)
    },
    setChannelLoading (loading) {
      this.channelLoading = loading
    }
  },
  beforeDestroy () {
    window.removeEventListener('message', this.sendJobPostingInfo)
  },
  watch: {
    postingChannels: {
      handler () {
        this.refresh()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-dialog-container {

  .post-history-container {
    padding-top: 23px;

    .collapse-label {
      position: absolute;
      right: 70px;
      height: 15px;
      font-size: 12px;
      font-weight: 400;
      color: #606266;
      line-height: 15px;
    }

    .table-container {
      position: relative;
      border: 1px solid #D9D9D9;

      .status-container {
        display: flex;
        align-items: center;

        .status-label {
          width: 70px;
          height: 15px;
          font-size: 12px;
          font-weight: 400;
          line-height: 15px;
          &.status-PENDING {
            color: #F4A958;
          }
          &.status-FINISHED {
            color: #51BF82;
          }
        }
        .status-icon {
          font-size: 6px;
          position: relative;
        }
      }

      .channel-container {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        &:last-child {
          margin: 0;
        }

        .op-icon {
          width: 17px;
          height: 17px;
          background-image: url($baseDomain + 'static/image/job_list_sprite.png?v=2018100801');
          margin-right: 20px;
          &.op-status-ADD {
            background-position: -37px -362px;
          }
          &.op-status-DELETE {
            background-position: -136px -362px;
          }
          &.op-status-UPDATE {
            background-position: -87px -362px;
          }
        }

        .channel-icon {
          height: 28px;
          width: 60px;
          background-repeat: no-repeat;
          background-position: center;
        }

        .status-icon {
          width: 17px;
          height: 17px;
          margin-left: 20px;
          background-image: url($baseDomain + 'static/image/job_list_sprite.png?v=2018100801');
          &.task-status-PENDING {
            background-position: -240px -362px
          }
          &.task-status-FINISHED {
            background-position: -186px -362px
          }
        }
      }

      .history-loading {
        position: absolute;
      }
    }

    .pagination-container {
      text-align: center;
      margin-top: 10px;
    }

    ::v-deep .el-collapse {
      border: 0;

      .el-collapse-item__arrow {
        -webkit-transform: rotate(-90deg);
        transform: rotate(-90deg);

        &.is-active {
          -webkit-transform: rotate(90deg);
          transform: rotate(90deg);
        }
      }

      .el-collapse-item__header {
        background-color: unset;
        border-bottom: 0;
      }

      .el-collapse-item__wrap {
        border-bottom: 0;
      }

      .el-table__header {
        .el-table__cell {
          background: #F9F9F9;
          height: 15px;
          font-size: 12px;
          font-weight: 500;
          color: #303133;
          line-height: 15px;
        }
      }

      .el-table__body-wrapper {
        overflow-y: auto;
        max-height: 383px;
        min-height: 46px;

        .cell {
          overflow: unset;
        }
      }
    }
  }

  .title-label {
    height: 23px;
    font-size: 17px;
    font-weight: 500;
    color: #303133;
    line-height: 23px;
  }
}

.channel-account {
  .el-radio-group {
    .el-radio {
      line-height: 26px;
    }
  }
}

.channel-icon {
  background-size: 100%;
}

.channel-ajinga {
  background-image: url($baseDomain + 'static/image/posting_channel/ajinga_en.png');
}

.channel-51job {
  background-image: url($baseDomain + 'static/image/posting_channel/51job.png');
}

.channel-zhaopin {
  background-image: url($baseDomain + 'static/image/posting_channel/zhaopin.png');
}

.channel-liepin {
  background-image: url($baseDomain + 'static/image/posting_channel/liepin.png');
}

.channel-58 {
  background-image: url($baseDomain + 'static/image/posting_channel/58.png');
}

.channel-ganji {
  background-image: url($baseDomain + 'static/image/posting_channel/ganji.png');
}

.channel-veryeast {
  background-image: url($baseDomain + 'static/image/posting_channel/veryeast.png');
}

.channel-shixiseng {
  background-image: url($baseDomain + 'static/image/posting_channel/shixiseng.png');
}

.channel-linkedin {
  background-image: url($baseDomain + 'static/image/posting_channel/linkedin.png');
}

.channel-jobstreet {
  background-image: url($baseDomain + 'static/image/posting_channel/jobstreet.png');
}

.channel-wotui {
  background-image: url($baseDomain + 'static/image/posting_channel/wotui.png');
}

.channel-jobsdb {
  background-image: url($baseDomain + 'static/image/posting_channel/jobsdb.png');
}

.channel-zzjob88 {
  background-image: url($baseDomain + 'static/image/posting_channel/zzjob88.png');
}

.channel-104 {
  background-image: url($baseDomain + 'static/image/posting_channel/104.jpg');
  background-position: -10px 50%;
}

.channel-indeed {
  background-image: url($baseDomain + 'static/image/posting_channel/indeed.jpg');
}

.channel-parttime {
  background-image: url($baseDomain + 'static/image/posting_channel/parttime.png');
}

.channel-agency {
  background-image:  url($baseDomain + 'static/images_en/default.jpg');
}

.channel-lagou {
  background-image: url($baseDomain + 'static/image/posting_channel/lagou.png');
  background-size: 80%;
}

.channel-boss {
  background-image: url($baseDomain + 'static/image/posting_channel/boss.png');
  background-size: 80%;
}

.channel-hrol {
  background-image: url(~@/assets/image/postingChannel/hrol.png);
  background-size: 90%;
}

.channel-91job {
  background-image: url(~@/assets/image/postingChannel/91job.png);
  background-size: 90%;
}

.channel-yimaitongdao {
  background-image: url(~@/assets/image/postingChannel/yimaitongdao.svg);
}

.channel-liepin_agency {
  background-image: url(~@/assets/image/postingChannel/liepin_agency.png);
}

.channel-maimai {
  background-image: url(~@/assets/image/postingChannel/maimai.png);
  background-size: 68%;
}

.channel-gooood {
  background-image: url(~@/assets/image/postingChannel/gooood.jpg);
}
</style>

<style lang="scss">
.channel-operation-container {
  &.el-dropdown-menu  {
    padding: 0;

    .el-dropdown-menu__item {
      &:hover {
        background: #F0F0F0;
      }
    }
  }

  &.el-popper {
    .popper__arrow {
      display: none;
    }
  }
}
.el-popover.light-tooltip-popper {
  &.el-popper {
    padding: 0;
  }
}
</style>
